import React from 'react';

const Avatar = ({ screenName, index=3 }) => {
	return (
		<span className="green_avatar avatar">
			<span>{screenName[0]}</span>
		</span>
	);
}

export { Avatar };
